import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-soot-200 bg-soot-900 text-soot-200">
      <div className="ik-container py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <p className="font-display text-2xl font-semibold text-white">iKominiarz.pl</p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-soot-400">
              Marketplace sprawdzonych kominiarzy. Znajdź fachowca, umów przegląd i pilnuj terminów pod ubezpieczenie nieruchomości.
            </p>
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wider text-soot-400">Nawigacja</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/chimneys" className="transition hover:text-white">Kominiarze</Link></li>
              <li><Link to="/contact" className="transition hover:text-white">Kontakt</Link></li>
              <li><Link to="/register-chimney" className="transition hover:text-white">Dla kominiarzy</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wider text-soot-400">Konto</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/login" className="transition hover:text-white">Zaloguj się</Link></li>
              <li><Link to="/register" className="transition hover:text-white">Zarejestruj się</Link></li>
              <li><a href="mailto:kontakt@ikominiarz.pl" className="transition hover:text-white">kontakt@ikominiarz.pl</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-soot-800 pt-6 text-xs text-soot-500">
          © {new Date().getFullYear()} iKominiarz.pl
        </div>
      </div>
    </footer>
  );
};

export default Footer;
